// extracted by mini-css-extract-plugin
export default {"old":"versions_diff-module__old--3-_3k","new":"versions_diff-module__new--2XOZq"};